/* eslint-disable */
/* tslint:disable */
// @ts-ignore
export default {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M28.197 24L47.049 5.398c1.173-1.139 1.173-3.024 0-4.198a3.051 3.051 0 00-4.233 0L23.964 19.803 5.113 1.2a3.051 3.051 0 00-4.233 0C-.293 2.339-.293 4.224.88 5.398L19.732 24 .88 42.602c-1.173 1.139-1.173 3.024 0 4.198.569.569 1.352.853 2.134.853.783 0 1.53-.284 2.135-.853L24 28.197 42.851 46.8c.57.569 1.352.853 2.135.853.782 0 1.529-.284 2.134-.853 1.173-1.139 1.173-3.024 0-4.198z"/>'
}
